import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_NL_UQ || "uq.nl.styling-book",
  ugcClientId: process.env.REACT_APP_UGC_CLIENT_ID_NL_UQ || "uqnl-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_NL_UQ || 24217,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_NL_UQ || 24218,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_NL_UQ ||
    "1:160978693362:web:93c2389d8518299947346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-G5V4WK3ZWY" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: false,
  showDualPrice: true,
  languages: [LANGUAGE.NL, LANGUAGE.EN],
  countryRegion: "Europe/Amsterdam",
  timeZone: {
    [LANGUAGE.NL]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2
      }
    },
    [LANGUAGE.EN]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2
      }
    }
  },
  dateFormat: {
    [LANGUAGE.NL]: "<dd>/<mm>/<yyyy>",
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  shortDateFormat: {
    [LANGUAGE.NL]: "<dd>/<mm>",
    [LANGUAGE.EN]: "<dd>/<mm>"
  },
  requireDecimal: true,
  memberPricingEnabled: true
};

export default _countryEnv;
